import { setTerms } from './helpers';

export const setReadyBusinessTypes = setTerms('ready_business_types');
